export const INVOICE_DATA = {
  paymentReceived: 0,
  paymentExpected: 0,
  dueDate: '',
  shipping: 0,
  salesTax: 0,
  discount: 0,
  invoiceId: 0,
};
